import React from "react"
import { DialogActions as Actions, Box, makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    padding: ({ isInline, stickyActions }) => {
      // Mobile
      if (isInline && stickyActions) {
        return theme.spacing(1, 2, 1, 2)
      }

      if (isInline && !stickyActions) {
        return theme.spacing(2, 0, 0, 0)
      }

      // Desktop
      if (!isInline && stickyActions) {
        return theme.spacing(2, 3, 2, 3)
      }

      return theme.spacing(2, 0, 0, 0)
    },
    display: "flex",
    gap: ({ isInline }) => (isInline ? theme.spacing(1) : 0),
    "& > *": {
      width: ({ isInline }) => (isInline ? "100%" : "inherit") // Fullwidth buttons in inline actions
    }
  }
}))

const DialogActions = ({ id = "dialog-actions", children, isInline = false, stickyActions, className }) => {
  const classes = useStyles({ isInline, stickyActions })

  if (!children) {
    return null
  }

  if (isInline) {
    return (
      <Box id={id} className={[classes.root, className].join(" ")}>
        {children}
      </Box>
    )
  }

  return (
    <Actions id={id} className={[classes.root, className].join(" ")}>
      {children}
    </Actions>
  )
}

export { DialogActions }
